import { HOST, PLATFORM_HOST } from "../../settings/setting";
import { authFecth } from "../../helpers/authFecth";
import { getToken } from "../auth/auth.service";

export interface BackgroundApplicant {
  id: string;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  email?: string;
  order_status?: string | null;
  approval_status?: string | null;
  report_available?: boolean;
}

export interface BackgroundOrder {
  id: string;
  main_recipient: string;
  paid?: boolean;
  invoice_url?: string | null;
  created_at?: string;
  updated_at?: string;
  applicants?: BackgroundApplicant[];
}

export const getBackgroundOrdersByEmail = async (): Promise<
  BackgroundOrder[]
> => {
  return (await authFecth(`${HOST}/api/background/orders`, "get", null)) as
    | BackgroundOrder[]
    | [];
};

export const getBackgroundOrderById = async (
  orderId: string,
): Promise<BackgroundOrder> => {
  return (await authFecth(
    `${HOST}/api/background/orders/${orderId}`,
    "get",
    null,
  )) as BackgroundOrder;
};

export const startBackgroundOrder = async (
  orderId: string,
): Promise<{ success: boolean; order_id: string; started_count: number }> => {
  return (await authFecth(
    `${HOST}/api/background/orders/${orderId}/start`,
    "post",
    null,
  )) as { success: boolean; order_id: string; started_count: number };
};

export const createBackgroundPaymentSession = async (payload: {
  first_name: string;
  middle_name?: string;
  last_name: string;
  email: string;
  success_url: string;
  cancel_url: string;
}): Promise<{ url: string }> => {
  const response = await fetch(
    `${PLATFORM_HOST}/api/background/payment/createPaymentSession`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    },
  );

  if (!response.ok) {
    throw new Error("Unable to create background payment session");
  }

  return (await response.json()) as { url: string };
};

export const getBackgroundReportHtml = async (
  applicantId: string,
): Promise<string> => {
  const token = await getToken();
  const response = await fetch(`${HOST}/api/background/report/html/${applicantId}`, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response.text();
};
